import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';
import '../Pagination.css';
import '../Alumnos/MDAlumnos.css';
import * as constantClass from '../fileWithConstants';
import { runMdMutation, isMdMutationLocked } from '../../services/mdMutationGuard';
import { MD_PAGE_SIZE, fetchAndApplyIndexPage } from '../../services/mdServerIndex';
import { ConfirmDialog } from '../common/ConfirmDialog';
import {
  buildStandardRowActions,
  MdRowActions,
  MdTableActionsCell,
  MdTableCell,
  MdTableHeaderCell,
} from '../common/MdRowActions';
import { PlusIcon, SearchIcon } from '../common/mdPageIcons';

function canGenerarActa(mesa) {
  const fin = new Date(mesa.mesaExamenFechaFinInscripcion);
  fin.setHours(0, 0, 0, 0);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return fin < today && mesa.generarActa;
}

function formatPeriodoExamenResumen(mesa) {
  const periodo = (mesa.periodoExamenDescripcion || '').trim();
  const llamado = (mesa.periodoExamenLlamado || '').trim();
  const anio = (mesa.anioAcademicoDescripcion || '').trim();
  return [periodo, llamado, anio].filter(Boolean).join(' - ');
}

export class MDMesaExamen extends Component {
  static displayName = MDMesaExamen.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      searchInput: '',
      perPage: MD_PAGE_SIZE,
      paginationData: [],
      totalCount: 0,
      pageCount: 0,
      offset: 0,
      currentPage: 0,
      showErrorMessage: false,
      errorMessage: '',
      successMessage: '',
      deletingId: null,
      generatingId: null,
      pendingDelete: null,
      pendingActa: null,
    };
    this.searchInputRef = React.createRef();
  }

  componentDidMount() {
    if (constantClass.canAccess('WWMesaExamen')) {
      this.populateData();
    }
  }

  handleRemoveItem = (mesa) => {
    if (isMdMutationLocked(this)) return;
    this.setState({
      pendingDelete: {
        id: mesa.mesaExamenCod,
        nombre: mesa.materiaCarreraNombre,
      },
    });
  };

  handleGenerarActaRequest = (mesa) => {
    if (isMdMutationLocked(this)) return;
    this.setState({
      pendingActa: {
        id: mesa.mesaExamenCod,
        nombre: mesa.materiaCarreraNombre,
      },
    });
  };

  handleCancelDelete = () => {
    if (this.state.deletingId) return;
    this.setState({ pendingDelete: null });
  };

  handleConfirmDelete = () => {
    const { pendingDelete } = this.state;
    if (!pendingDelete || isMdMutationLocked(this)) return;
    this.deleteItem(pendingDelete.id);
  };

  handleCancelActa = () => {
    if (this.state.generatingId) return;
    this.setState({ pendingActa: null });
  };

  handleConfirmActa = () => {
    const { pendingActa } = this.state;
    if (!pendingActa || isMdMutationLocked(this)) return;
    this.generarActa(pendingActa.id);
  };

  handlePageClick = (e) => {
    this.populateData(e.selected, this.state.searchInput);
  };

  handleSearchInputChange = (e) => {
    const searchInput = e.target.value;
    const cleared = searchInput.trim() === '';
    this.setState({ searchInput, successMessage: '', showErrorMessage: false, errorMessage: '' });
    if (cleared && this.state.searchInput.trim() !== '') {
      this.populateData(0, '', { background: false });
    }
  };

  clearFeedback = () => {
    this.setState({ successMessage: '', showErrorMessage: false, errorMessage: '' });
  };

  handleSearchSubmit = (e) => {
    e.preventDefault();
    const search = (this.searchInputRef.current
      ? this.searchInputRef.current.value
      : this.state.searchInput).trim();
    this.setState({ searchInput: search });
    this.populateData(0, search, { background: false });
  };

  buildRowActions(mesa) {
    const id = mesa.mesaExamenCod;
    const extraActions = [];

    if (canGenerarActa(mesa)) {
      extraActions.push({
        key: 'acta',
        label: this.state.generatingId === id ? 'Generando...' : 'Acta',
        variant: 'primary',
        icon: 'document',
        onClick: () => this.handleGenerarActaRequest(mesa),
        disabled: this.state.loading || this.state.generatingId === id,
      });
    }

    return buildStandardRowActions({
      editTo: '/update-mex/' + id + '/0',
      onDelete: () => this.handleRemoveItem(mesa),
      deleteDisabled: this.state.loading || this.state.deletingId === id,
      deleteLabel: this.state.deletingId === id ? 'Eliminando...' : 'Borrar',
      detailTo: '/update-mex/' + id + '/1',
      extraActions,
    });
  }

  renderTable(mesas) {
    return (
      <div className="md-page__table-card">
        <table className="md-page__table md-page__table--actions-fixed md-mesa-examen__table" aria-labelledby="md-mesa-examen-title">
          <colgroup>
            <col className="md-mesa-examen__col-materia" />
            <col className="md-mesa-examen__col-carrera" />
            <col className="md-mesa-examen__col-periodo" />
            <col className="md-mesa-examen__col-fecha-examen" />
            <col className="md-mesa-examen__col-inicio-inscripcion" />
            <col className="md-mesa-examen__col-fin-inscripcion" />
            <col className="md-mesa-examen__col-actions" />
          </colgroup>
          <thead>
            <tr>
              <MdTableHeaderCell cellType="text">Materia</MdTableHeaderCell>
              <MdTableHeaderCell cellType="text">Carrera</MdTableHeaderCell>
              <MdTableHeaderCell cellType="text" className="md-mesa-examen__cell md-mesa-examen__cell--periodo">Período de Examen</MdTableHeaderCell>
              <MdTableHeaderCell cellType="date" className="md-mesa-examen__cell md-mesa-examen__cell--fecha-examen">Fecha de Examen</MdTableHeaderCell>
              <MdTableHeaderCell cellType="date" className="md-mesa-examen__cell md-mesa-examen__cell--inicio-inscripcion">Inicio Inscripción</MdTableHeaderCell>
              <MdTableHeaderCell cellType="date" className="md-mesa-examen__cell md-mesa-examen__cell--fin-inscripcion">Fin Inscripción</MdTableHeaderCell>
              <th scope="col" className="md-page__table__actions-header" aria-label="Acción" />
            </tr>
          </thead>
          <tbody>
            {mesas.map((mesa) => (
              <tr key={mesa.mesaExamenCod}>
                <MdTableCell cellType="text">{mesa.materiaCarreraNombre}</MdTableCell>
                <MdTableCell cellType="text">{mesa.carreraNombre}</MdTableCell>
                <MdTableCell cellType="text" className="md-mesa-examen__cell md-mesa-examen__cell--periodo">
                  {formatPeriodoExamenResumen(mesa)}
                </MdTableCell>
                <MdTableCell cellType="date" className="md-mesa-examen__cell md-mesa-examen__cell--fecha-examen">
                  {constantClass.formatDisplayDate(mesa.mesaExamenFechaExamen)}
                </MdTableCell>
                <MdTableCell cellType="date" className="md-mesa-examen__cell md-mesa-examen__cell--inicio-inscripcion">
                  {constantClass.formatDisplayDate(mesa.mesaExamenFechaInicioInscripci)}
                </MdTableCell>
                <MdTableCell cellType="date" className="md-mesa-examen__cell md-mesa-examen__cell--fin-inscripcion">
                  {constantClass.formatDisplayDate(mesa.mesaExamenFechaFinInscripcion)}
                </MdTableCell>
                <MdTableActionsCell>
                  <MdRowActions items={this.buildRowActions(mesa)} />
                </MdTableActionsCell>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    const isBusy = this.state.loading || this.state.searching;
    const listLoading = this.state.loading && !this.state.deletingId && !this.state.generatingId;
    const { pendingDelete, pendingActa } = this.state;

    const contents = listLoading
      ? <p className="md-page__loading"><em>Cargando datos...</em></p>
      : this.renderTable(this.state.paginationData);

    return (
      <div className="md-page md-mesa-examen">
        <h1 id="md-mesa-examen-title" className="md-page__title">Manejar Datos de Mesas de Examen</h1>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">
              {this.state.errorMessage}
            </div>
          ) : null}
          {this.state.successMessage ? (
            <div className="md-page__success">{this.state.successMessage}</div>
          ) : null}
        </div>

        <div className="md-page__toolbar">
          <Link className="md-page__action-link" to="/add-mex">
            <PlusIcon />
            Nueva Mesa de Examen
          </Link>
          <Link className="md-page__action-link" to="/cme">
            <PlusIcon />
            Cargar Mesas desde archivo
          </Link>
        </div>

        <form className="md-page__search-row" onSubmit={this.handleSearchSubmit}>
          <div className="md-page__search-wrap">
            <span className="md-page__search-icon">
              <SearchIcon />
            </span>
            <input
              ref={this.searchInputRef}
              className="md-page__search-input"
              type="text"
              name="search"
              autoComplete="off"
              disabled={isBusy}
              placeholder="Ingrese el nombre de la materia"
              value={this.state.searchInput}
              onChange={this.handleSearchInputChange}
            />
          </div>
          <button type="submit" className="md-page__search-btn" disabled={isBusy}>
            Buscar
          </button>
        </form>

        {contents}

        {!listLoading && this.state.pageCount > 0 ? (
          <div className="md-page__pagination">
            <ReactPaginate
              previousLabel="Anterior"
              nextLabel="Siguiente"
              breakLabel="..."
              breakClassName="break-me"
              pageCount={this.state.pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              forcePage={Math.floor(this.state.offset / this.state.perPage)}
              onPageChange={this.handlePageClick}
              containerClassName="pagination"
              subContainerClassName="pages pagination"
              activeClassName="active"
            />
          </div>
        ) : null}

        <ConfirmDialog
          open={Boolean(pendingDelete)}
          title="Eliminar mesa de examen"
          message="Esta acción eliminará la mesa de examen del sistema y no se puede deshacer."
          detail={pendingDelete ? pendingDelete.nombre : ''}
          confirmLabel="Eliminar"
          cancelLabel="Cancelar"
          variant="danger"
          loading={Boolean(this.state.deletingId)}
          onConfirm={this.handleConfirmDelete}
          onCancel={this.handleCancelDelete}
        />

        <ConfirmDialog
          open={Boolean(pendingActa)}
          title="Generar acta de examen"
          message="Se generarán las actas de examen para esta mesa. ¿Desea continuar?"
          detail={pendingActa ? pendingActa.nombre : ''}
          confirmLabel="Generar"
          cancelLabel="Cancelar"
          variant="primary"
          loading={Boolean(this.state.generatingId)}
          onConfirm={this.handleConfirmActa}
          onCancel={this.handleCancelActa}
        />
      </div>
    );
  }

  async populateData(page = 0, search = '', options = {}) {
    await fetchAndApplyIndexPage(this, {
      indexUrl: 'api/mex/Index',
      page,
      search: typeof search === 'string' ? search.trim() : '',
      perPage: this.state.perPage,
      background: options.background,
    });
  }

  async deleteItem(id) {
    this.clearFeedback();
    this.setState({ deletingId: id });
    await runMdMutation(this, async () => {
      const { data } = await constantClass.apiFetch('api/mex/delete/' + id, {
        method: 'POST',
      });
      if (data === 'Timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      if (constantClass.isApiError(data)) {
        this.setState({
          showErrorMessage: true,
          errorMessage: constantClass.getApiErrorMessage(
            data,
            'No se pudo eliminar la mesa de examen. Verifique si tiene registros asociados e intente nuevamente.'
          ),
          pendingDelete: null,
        });
        return;
      }
      this.setState({ successMessage: 'La mesa de examen se eliminó correctamente.', pendingDelete: null });
      await this.populateData(this.state.currentPage, this.state.searchInput);
    });
    this.setState({ deletingId: null });
  }

  async generarActa(id) {
    this.clearFeedback();
    this.setState({ generatingId: id });
    await runMdMutation(this, async () => {
      const { data } = await constantClass.apiFetch('api/aex/generate/' + id, {
        method: 'POST',
      });
      if (data === 'Timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      if (constantClass.isApiError(data) || data === 'Forbidden.') {
        this.setState({
          showErrorMessage: true,
          errorMessage: constantClass.getApiErrorMessage(
            data,
            'No se pudo generar el acta. Intente nuevamente.'
          ),
          pendingActa: null,
        });
        return;
      }
      this.setState({
        successMessage: 'Actas generadas correctamente. Puede imprimirlas desde Actas de Exámenes.',
        pendingActa: null,
      });
      await this.populateData(this.state.currentPage, this.state.searchInput);
    });
    this.setState({ generatingId: null });
  }
}
